import useSWR from 'swr';
import fetcher from 'lib/fetcher';
import { ISelectItemExpended } from './use-building-by-street';
import { sortByTitle } from 'lib/utils';
export type IBuildingsByComplexItem = {
  commissioningQuarter: string;
  coordinates?: { latitude: number; longitude: number };
  id: number;
  title: string;
};
export interface IBuildingsByComplexResponse {
  buildings: IBuildingsByComplexItem[];
}

const useBuildingsByComplexId = (id?: number | null, isTransformForSelect?: boolean) => {
  const { data, error, isLoading } = useSWR(
    id ? `/apartment-complexes/${id}/buildings` : null,
    (url) => (id ? fetcher.swr<IBuildingsByComplexResponse>(url) : null),
    { errorRetryCount: 0, revalidateOnFocus: false },
  );

  const transformData = (
    dataList: IBuildingsByComplexResponse | undefined | null,
  ): ISelectItemExpended[] => {
    if (dataList) {
      const dataTransformed = dataList.buildings.map((item) => ({
        key: item.id,
        label: item.title,
        coordinates: item.coordinates,
      }));
      return sortByTitle(dataTransformed) as ISelectItemExpended[];
    }
    return [];
  };

  return {
    building: isTransformForSelect ? transformData(data) : data?.buildings ?? [],
    error,
    isLoading,
  };
};

export default useBuildingsByComplexId;
